import { render, staticRenderFns } from "./ModificationServiceReference.vue?vue&type=template&id=5e6cc373"
import script from "./ModificationServiceReference.vue?vue&type=script&lang=js"
export * from "./ModificationServiceReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports